
import { Component, Prop, Vue } from "vue-property-decorator";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import getFullName from "@/helpers/getFullName";

@Component({
  components: {
    CircleWithInitials    
  }
})
export default class GroupConversationParticipants extends Vue {
@Prop({ type: Array, required: true }) readonly participants!: any[];

  participantsLimit: number = 5;
  
  getFullName = getFullName;

  get participantsToShow() {
    return this.participants.slice(0, this.participantsLimit);
  }

  get participantsOverTheLimit(): number {
    return this.participants.length - this.participantsLimit;
  }

  get participantsMoreThanLimit(): boolean {
    return this.participants.length > this.participantsLimit;
  }
}
